import { Label } from "@/components/ui/label";
import { Panel } from "./Panel";
import { RateInput } from "./RateInput";
import { getIn } from "./ratePaths";

const slug = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, "-");

/** A set of single-figure fees, laid out as labelled inputs. */
export const FieldGroup = ({ service, group, draft, onChange }) => (
  <Panel
    title={group.title}
    help={group.help}
    testId={`rate-card-group-${service}-${slug(group.title)}`}
  >
    <div className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2 xl:grid-cols-3">
      {group.fields.map((field) => {
        const path = `${service}.${field.path}`;
        const id = `rate-${path.replace(/\./g, "-")}`;
        return (
          <div key={field.path}>
            <Label htmlFor={id} className="text-[13px] font-semibold leading-snug">
              {field.label}
            </Label>
            <div className="mt-1.5">
              <RateInput
                testId={`rate-input-${path}`}
                ariaLabel={field.label}
                kind={field.type}
                value={getIn(draft, path)}
                onChange={(value) => onChange(path, value)}
              />
            </div>
            {field.help ? (
              <p className="mt-1.5 text-xs leading-relaxed text-muted-foreground">{field.help}</p>
            ) : null}
          </div>
        );
      })}
    </div>
  </Panel>
);
